import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, School, Trophy, Target } from 'lucide-react';
const targets = [{
  icon: <BatteryWarning size={32} className="text-brand-orange" data-id="element-294" />,
  title: 'Docentes agotadas/os de improvisar',
  desc: 'Maestras y maestros de primaria que repiten lo mismo sin que los alumnos avancen hacia los contenidos del grado.'
}, {
  icon: <School size={32} className="text-brand-green" data-id="element-295" />,
  title: 'Enseñás en escuela pública o privada',
  desc: 'Con pizarrón, fotocopiadora y ganas te alcanza. Sin tecnología cara ni recursos especiales.'
}, {
  icon: <Trophy size={32} className="text-brand-gold" data-id="element-296" />,
  title: '🆕 Docentes que quieren destacarse',
  desc: 'Querés que tu carpeta didáctica sea sólida y que tu directora lo note en la próxima supervisión.'
}, {
  icon: <Target size={32} className="text-brand-amber" data-id="element-297" />,
  title: 'Buscás resultados concretos',
  desc: 'Vas por alumnos que comprendan fracciones, multiplicación, geometría y resolución de problemas de verdad.'
}];
export const WhoIsItFor = () => {
  return <section className="py-20 bg-brand-green text-white" data-id="element-298">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299">
        <div className="text-center mb-16" data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4 text-brand-gold" data-id="element-301">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-xl text-cream/90" data-id="element-302">
            Diseñado para vos si querés que tus clases de matemática tengan
            estructura real
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-303">
          {targets.map((target, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/15 transition" data-id="element-304">
              <div className="bg-white p-3 rounded-xl inline-block mb-6 shadow-sm" data-id="element-305">
                {target.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-306">{target.title}</h3>
              <p className="text-cream/80 leading-relaxed" data-id="element-307">{target.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-308">
          <a href="#pricing" className="inline-flex items-center gap-2 text-brand-gold hover:text-white font-bold text-lg transition group" data-id="element-309">
            ¿No estás segura/o si es para vos? Tenés 7 días de garantía
            <span className="group-hover:translate-x-1 transition-transform" data-id="element-310">
              →
            </span>
          </a>
        </div>
      </div>
    </section>;
};